import '../../style/base.css';
import '../../info/index.css';
import '../../icon/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/image/style/index.js
// module id = 420
// module chunks = 0